import appConstants from '@appConstants';
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { formatDateTime } from '@dataGrid/gridUtilities';
import { driverCommentsConstants } from './constants';

export default class GridConfig {
  config: ReturnType<typeof GridConfig.getDefaultConfiguration>;

  constructor() {
    this.config = GridConfig.getDefaultConfiguration();
  }

  static createdDateTimeValueGetter = (params: {
    data?: {createdDateTime?: string};
  }) => {
    if (!params?.data) {
      return '';
    }
    return formatDateTime({value: params.data.createdDateTime});
  };

  static getDefaultConfiguration() {
    return {
      title: driverCommentsConstants.GRID_NAME,
      keyColumn: 'rowId',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: MultiSelectFilter
      },
      columns: [
        {
          headerName: driverCommentsConstants.LABEL.DRIVER,
          headerTooltip: driverCommentsConstants.LABEL.DRIVER,
          field: 'driverName',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_150
        },
        {
          headerName: driverCommentsConstants.LABEL.DRIVER_NUMBER,
          headerTooltip: driverCommentsConstants.LABEL.DRIVER_NUMBER,
          field: 'driverNumber',
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120
        },
        {
          headerName: driverCommentsConstants.LABEL.COMMENTS,
          headerTooltip: driverCommentsConstants.LABEL.COMMENTS,
          field: 'notes',
          tooltipField: 'notes',
          tooltipValueGetter: (params) => params.value,
          filter: MultiSelectFilter,
          flex: 1,
          minWidth: appConstants.columnWidth.W_200
        },
        {
          headerName: driverCommentsConstants.LABEL.TIMESTAMP,
          headerTooltip: driverCommentsConstants.LABEL.TIMESTAMP,
          field: 'createdDateTime',
          filter: DateTimeFilter,
          valueGetter: GridConfig.createdDateTimeValueGetter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATETIME,
            useGetterValue: true
          },
          minWidth: appConstants.columnWidth.W_140
        }
      ]
    };
  }
}
